/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
export default {
  getHostUrl: (url: string = window?.location?.href): string => {
    if (!url) {
      throw new Error('Invalid URL');
    }

    const baseURL = new URL(url);
    const segments = baseURL.hostname.split('.');
    const backendUrl = baseURL.searchParams.get('backend');

    switch (baseURL.protocol) {
      case 'ws:':
        baseURL.protocol = 'http:';

        break;
      case 'wss:':
        baseURL.protocol = 'https:';

        break;

      default:
        break;
    }

    if (backendUrl) {
      return backendUrl;
    }

    if (segments.length === 2) {
      segments.unshift('pcast');
    } else if (
      segments[0].startsWith('stg-') ||
      segments[0].endsWith('-stg') ||
      segments[0].includes('-stg-') ||
      segments[0] === 'stg'
    ) {
      segments[0] = 'pcast-stg';
    } else if (segments[0].startsWith('local') || segments[0].endsWith('-local')) {
      // Leave URL unchanged
    } else {
      segments[0] = 'pcast';
    }

    baseURL.hostname = segments.join('.');

    return baseURL.origin;
  },
  getIngestUrl: (url: string = window?.location?.href): URL => {
    if (!url) {
      throw new Error('Invalid URL');
    }

    const baseURL = new URL(url);
    const backendUrl = baseURL.searchParams.get('backend');
    const segments = backendUrl ? new URL(backendUrl).hostname.split('.') : baseURL.hostname.split('.');

    switch (baseURL.protocol) {
      case 'ws:':
        baseURL.protocol = 'http:';

        break;
      case 'wss:':
        baseURL.protocol = 'https:';

        break;

      default:
        break;
    }

    if (segments.length === 2) {
      segments.unshift('ingest');
    } else if (segments[0] === 'stg') {
      segments[0] = 'ingest-stg';
    } else if (
      segments[0].startsWith('stg-') ||
      segments[0].endsWith('-stg') ||
      segments[0].includes('-stg-')
    ) {
      const dashedSegmentsWithNoPcast = segments[0].split('-').filter(segment => segment !== 'pcast');

      segments[0] = dashedSegmentsWithNoPcast.join('-').replace('stg', 'ingest-stg');
    } else if (segments[0].split('-').includes('pcast')) {
      segments[0] = segments[0].replace('pcast', 'ingest');
    } else if (segments[0].startsWith('local') || segments[0].endsWith('-local')) {
      // Leave URL unchanged
    } else {
      segments[0] = 'ingest';
    }

    baseURL.hostname = segments.join('.');

    return baseURL;
  }
};